import React, { useState } from "react";
import { Button, Col, Row, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useStore } from "store";
import ReactTooltip from 'react-tooltip';
import css from "./Viewer.module.css";
import { useWordpress } from "utils"
import { IoMdShareAlt, IoMdDownload, IoMdRefresh } from "react-icons/io"
import { useTranslation } from "react-i18next";
import { PDFDownloadLink } from '@react-pdf/renderer';
import PdfDocument from "./pdf/PdfDocument"

function Viewer() {
	const { i18n } = useTranslation()
	const t = useStore(state => state.translations)
	const { data } = useWordpress()
	const [pdfReady, setPdfState] = useState(false)
	const [modal, setModal] = useState(false);

	const rotationId = useStore(state => state.rotation)
	const sizeId = useStore(state => state.size)
	const themeId = useStore(state => state.theme)
	const tableId = useStore(state => state.table)
	const ringId = useStore(state => state.ring)
	const powerSupply = useStore(state => state.powerSupply)

	const reset = useStore(state => state.reset)
	const url = encodeURI(window.location.href)

	const imageView = rotationId === "pole" ? "imagePoleFront" : "imageFront" 

	let theme = data.themes && data.themes[themeId] && data.themes[themeId]["imageFront"] && data.themes[themeId]["imageFront"].url
	let table = data.tables && data.tables[tableId] && data.tables[tableId][imageView] && data.tables[tableId][imageView].url
	let ring = data.rings && data.rings[ringId] && data.rings[ringId]["imageFront"] && data.rings[ringId]["imageFront"].url

	const size = sizeId || "size_180cm_x_55cm"

	const selectingFinished = sizeId

	function handleModel() {
		setModal(!modal)
	}

	function startPdfRender() {
        setPdfState(false)
		setTimeout(() => {
			setPdfState(true);
		}, 1);
		handleModel()
    }

	return (
		<>
			<Row>
				<ReactTooltip id='share' place="right" type='dark' effect='solid'>
					<span>{t.leftIcons.share[i18n.language]}</span>
				</ReactTooltip>
				<ReactTooltip id='download' place="right" type='dark' effect='solid'>
					<span>{t.leftIcons.export[i18n.language]}</span>
				</ReactTooltip>
				<ReactTooltip id='reset' place="right" type='dark' effect='solid'>
					<span>{t.leftIcons.reset[i18n.language]}</span>
				</ReactTooltip>

				<div className={css.icons}>				
					<Button className="mb-2" outline onClick={() => navigator.clipboard && navigator.clipboard.writeText(url)}>
						<IoMdShareAlt data-tip data-for="share" />
					</Button><br />
					<Button className="mb-2" outline onClick={startPdfRender} disabled={!selectingFinished}>
						<IoMdDownload data-tip data-for="download" />
					</Button><br />
					<Button outline onClick={reset}>
						<IoMdRefresh data-tip data-for="reset" />
					</Button>
				</div>
				<Modal isOpen={modal} className={css.modal}>
					<ModalHeader toggle={handleModel}>Exporting configuration into PDF</ModalHeader>
						<ModalBody>
							{pdfReady ? (
								"Your PDF is ready to download!"
							) : (
								"Loading document..."
							)}
						</ModalBody>
					<ModalFooter>
					{pdfReady && (
						<PDFDownloadLink document={<PdfDocument data={data} />} fileName="turnmytree-quote.pdf">
							{
								({ loading, error }) => (loading ? 'Loading document...' :
									<Button color="primary" onClick={() => setPdfState(false)}>
										Download PDF
									</Button>
								)
							}
						</PDFDownloadLink>
					)}
					{' '}
					<Button color="secondary" onClick={handleModel}>Cancel</Button>
					</ModalFooter>
				</Modal>
				<Col xs="12" className={css.block}>
					<div style={{ display: size === "size_180cm_x_55cm" ? "block" : "none" }}>
						<img rel="preload" className={css.theme} src={theme || `${process.env.PUBLIC_URL}/img/renders/size_180cm_x_55cm/front/Sidewall_white.png`} alt="" />
						<img rel="preload" className={css.table} src={table || `${process.env.PUBLIC_URL}/img/renders/size_180cm_x_55cm/front/${rotationId === "pole" ? "Top_white_pole.png" : "Acrylic_White_A.png"}`} alt="" />
						{rotationId !== "pole" && <img rel="preload" className={css.ring} src={ring || `${process.env.PUBLIC_URL}/img/renders/size_180cm_x_55cm/front/Ring_white.png`} alt="" />}
						{powerSupply && rotationId !== "pole" && <img rel="preload" className={css.plug} src={`${process.env.PUBLIC_URL}/img/Plug_TMT100.png`} alt="" />}
					</div>
					<div style={{ display: size === "size_125cm_x_55cm" ? "block" : "none" }}>
						<img rel="preload" className={css.theme} src={theme || `${process.env.PUBLIC_URL}/img/renders/size_125cm_x_55cm/front/Sidewall_white.png`} alt="" />
						<img rel="preload" className={css.table} src={table || `${process.env.PUBLIC_URL}/img/renders/size_125cm_x_55cm/front/Top_white.png`} alt="" />
						{rotationId !== "pole" && <img rel="preload" className={css.ring} src={ring || `${process.env.PUBLIC_URL}/img/renders/size_125cm_x_55cm/front/Ring_white.png`} alt="" />}
						{powerSupply && rotationId !== "pole" && <img rel="preload" className={css.plug} src={`${process.env.PUBLIC_URL}/img/Top_Plug_A.png`} alt="" />}
					</div>
					<div style={{ display: size === "size_100cm_x_30cm" ? "block" : "none" }}>
						<img rel="preload" className={css.theme} src={theme || `${process.env.PUBLIC_URL}/img/renders/size_100cm_x_30cm/front/Sidewall_white.png`} alt="" />
						<img rel="preload" className={css.table} src={table || `${process.env.PUBLIC_URL}/img/renders/size_100cm_x_30cm/front/Top_white.png`} alt="" />
						{rotationId !== "pole" && <img rel="preload" className={css.ring} src={ring || `${process.env.PUBLIC_URL}/img/renders/size_100cm_x_30cm/front/Ring_white.png`} alt="" />}
						{powerSupply && rotationId !== "pole" && <img rel="preload" className={css.plug} src={`${process.env.PUBLIC_URL}/img/Plug_TMT100.png`} alt="" />}
					</div>
				</Col>
			</Row>
		</>
	);
}

export default Viewer;
